module.exports=function(scope){ return `<label class="mdl-checkbox mdl-js-checkbox ${scope.cls}" for="${scope.id}-input">
    <input id="${scope.id}-input" class="mdl-checkbox__input" type="checkbox" value="${scope.value}" ${scope.checked}>
    <span class="mdl-checkbox__label">${scope.label}</span>
</label>`};